<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Referral for Testing</h2>

        <ul class="list-disc pl-4  font-light">
            <li>A suspected diagnosis was not clear at presentation</li>
            <li>A series of laboratory and imaging tests were conducted to investigate further</li>
        </ul>

        <div class="my-6 md:my-12 flex flex-col md:flex-row md:flex-wrap md:justify-center gap-4 md:gap-6">
            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-lightblue bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/common/antibody.svg" alt="Antibody icon" />

                <h5 class="text-2xl text-center ">Serologies</h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-purple bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/eskd/thrombosis-purple.svg" alt="Thrombosis icon" />

                <h5 class="text-2xl text-center ">Thrombosis workup</h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-darkerblue bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/eskd/person-icon.svg" alt="Human icon" />

                <h5 class="text-2xl text-center ">
                    Ischemia investigations (ultrasound of lower limbs, X-rays of hands and feet)
                </h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-maroon bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/eskd/kidneys-maroon.svg" class="h-14" alt="Kidneys icon" />

                <h5 class="text-2xl text-center ">Urinalysis, urine cultures, and blood cultures</h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-gold bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/eskd/heart-yellow.svg" alt="Human heart icon" />

                <h5 class="text-2xl text-center ">Cardiac workup (troponin-T test, ECG, CT)</h5>
            </div>
        </div>
    </div>
</template>
